export enum RouteMaterials {
  NEXT = "next",
  MORE = "more-materials",
  QUIZ = "quiz-materials",
}

export enum StatusMaterials {
  NEXT = "next",
  MORE = "more-materials",
  QUIZ = "quiz-materials",
}
